export default "__VITE_ASSET__CqgB2UD8__"